import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../GlobalDataContext/GlobalContext";
import {
  encryptString,
  createSession,
  getAbhaProfile,
} from "../../services/apiUtils";
import Loader from "../../components/common/Loader";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import { toast, ToastContainer } from "react-toastify";
import DeactivatePopup from "../../components/Forgot-ABHA/Account-deactivate-popup";

const LoginABHAAddress = ({ prefillAddress }) => {
  const [showOtpBox, setShowOtpBox] = useState(false);
  const [abhaAddress, setAbhaAddress] = useState(prefillAddress || "");
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [accessToken, setaccessToken] = useState("");
  const [txnId, settxnId] = useState("");
  const [resendTimer, setResendTimer] = useState("");
  const [OtpText, setOtpText] = useState("");
  const [showDeactivateMessage, setShowDeactivateMessage] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaSessionId, setCaptchaSessionId] = useState("");
  const [captchaImage, setCaptchaImage] = useState("");
  const [resendCount, setResendCount] = useState(1);
  const [abhaAddressError, setAbhaAddressError] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpSystem, setOtpSystem] = useState("");
  const [searchDone, setSearchDone] = useState(false);
  const [availableAuthMethods, setAvailableAuthMethods] = useState([]);
  const navigate = useNavigate();

  const { getDataByKey } = useContext(GlobalContext);

  // Update address when prefillAddress prop changes
  useEffect(() => {
    if (prefillAddress) {
      setAbhaAddress(prefillAddress);
      toast.info(`Address auto-filled: ${prefillAddress}`);
    }
  }, [prefillAddress]);

  const back = () => {
    if (showOtpBox) {
      setShowOtpBox(false);
      setResendCount(0);
    } else {
      getDataByKey("backfunction")?.();
    }
  };

  // Fetch captcha from backend
  const generateCaptcha = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/abha/captcha/generate`);
      if (response.data.success) {
        setCaptchaSessionId(response.data.data.sessionId);
        setCaptchaImage(response.data.data.captchaImage);
        setCaptchaInput("");
      } else {
        toast.error("Failed to generate captcha. Please try again.");
      }
    } catch (error) {
      console.error("Error generating captcha:", error);
      toast.error("Failed to generate captcha. Please try again.");
    }
  };

  // Initialize captcha on mount
  useEffect(() => {
    generateCaptcha();
  }, []);

  /**
   * Function used to handle ABHA address input
   */
  const handleAbhaAddressChange = (e) => {
    const value = e.target.value.toLowerCase().trim();
    setAbhaAddress(value);
    // Reset search state when address changes
    setSearchDone(false);
    setAvailableAuthMethods([]);
    setOtpSystem("");

    // Validate ABHA address
    if (value.length === 0) {
      setAbhaAddressError("ABHA address is required");
    } else if (!value.includes("@sbx")) {
      setAbhaAddressError("ABHA address must end with @sbx");
    } else if (!value.endsWith("@sbx")) {
      setAbhaAddressError("ABHA address must end with @sbx");
    } else if (value === "@sbx") {
      setAbhaAddressError("Please enter username before @sbx");
    } else {
      setAbhaAddressError("");
    }
  };

  /**
   * Search ABHA address to get available auth methods
   */
  const handleSearch = async () => {
    if (
      !abhaAddress ||
      !abhaAddress.endsWith("@sbx") ||
      abhaAddress === "@sbx"
    ) {
      setAbhaAddressError("Please enter a valid ABHA address ending with @sbx");
      toast.error("Please enter a valid ABHA address ending with @sbx");
      return;
    }

    setIsPageLoading(true);
    try {
      // const sessionResponse = await createSession();
      // if (!sessionResponse?.accessToken) {
      //   toast.error("Session creation failed. Please try again.");
      //   setIsPageLoading(false);
      //   return;
      // }

      // const token = sessionResponse.accessToken;
      // setaccessToken(token);

      const response = await axios.post(
        `${API_BASE_URL}/abha/profile/search`,
        { address: abhaAddress },
        {
          headers: {
            "Content-Type": "application/json",
            // accesstoken: token,
          },
        },
      );

      const data = response.data?.data || response.data;
      const methods = data.authMethods || [];
      if (methods.length === 0) {
        toast.error(
          "No authentication methods available for this ABHA address.",
        );
        setIsPageLoading(false);
        return;
      }
      setAvailableAuthMethods(methods);
      setSearchDone(true);
      // Auto-select if only one method available
      if (methods.length === 1) {
        setOtpSystem(methods[0] === "AADHAAR_OTP" ? "aadhaar" : "abdm");
      }
      toast.success(
        `ABHA address found for ${data.fullName || abhaAddress}. Please select verification method.`,
      );
    } catch (error) {
      if (
        error.response?.data?.message ===
        "This account is deactivated. Please continue to reactivate."
      ) {
        setShowDeactivateMessage(error.response.data.message);
      } else {
        toast.error(
          error.response?.data?.message ||
            "ABHA address not found. Please try again.",
        );
      }
    } finally {
      setIsPageLoading(false);
    }
  };

  /**
   * Function used to set otp text
   */
  const handleOtpChange = (e) => {
    const value = e.target.value;
    // Allow only digits and up to 6 characters
    if (/^\d{0,6}$/.test(value)) {
      setOtpText(value);
      // Validate OTP
      if (value.length === 0) {
        setOtpError("OTP is required");
      } else if (value.length < 6) {
        setOtpError("OTP must be 6 digits");
      } else {
        setOtpError("");
      }
    }
  };

  // Countdown logic using useEffect
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
      return () => clearTimeout(timer); // Cleanup timer on unmount
    }
  }, [resendTimer]);

  /**
   * function used to send otp for abha address verification
   */
  const handleSendOtp = async (event) => {
    event.preventDefault();

    // Validate ABHA address
    if (
      !abhaAddress ||
      !abhaAddress.endsWith("@sbx") ||
      abhaAddress === "@sbx"
    ) {
      toast.error("Please enter a valid ABHA address ending with @sbx");
      return;
    }

    // Validate OTP system selection
    if (!otpSystem) {
      toast.error("Please select an OTP verification method");
      return;
    }

    // Validate captcha with backend
    if (!captchaInput || captchaInput.trim() === "") {
      toast.error("Please enter the captcha.");
      return;
    }

    try {
      // Verify captcha with backend
      const captchaResponse = await axios.post(
        `${API_BASE_URL}/abha/captcha/validate`,
        {
          sessionId: captchaSessionId,
          captcha: captchaInput,
        },
      );

      if (!captchaResponse.data.success || !captchaResponse.data.valid) {
        toast.error("Invalid captcha. Please try again.");
        generateCaptcha(); // Regenerate captcha
        setCaptchaInput(""); // Clear input
        return;
      }
    } catch (error) {
      toast.error("Failed to validate captcha. Please try again.");
      generateCaptcha();
      setCaptchaInput("");
      return;
    }

    setIsPageLoading(true);
    try {
      // Encrypt ABHA address
      const encryptedAbhaAddress = await encryptString(abhaAddress);
      if (encryptedAbhaAddress) {
        // const sessionResponse = await createSession();
        // if (sessionResponse?.accessToken) {
          const url = `${API_BASE_URL}/abha/profile/singlelogin/api`;
          const param = {
            loginId: encryptedAbhaAddress,
            verify:
              otpSystem === "aadhaar" ? "aadhaar-verify" : "mobile-verify",
            otpsystem: otpSystem === "aadhaar" ? "aadhaar" : "abdm",
          };
          // const accessToken = sessionResponse.accessToken;
          // setaccessToken(accessToken);
          const header = {
            headers: {
              "Content-Type": "application/json",
              // accesstoken: accessToken,
            },
          };
          const response = await axios.post(url, param, header);
          const dtResponse = response.data;
          if (dtResponse.success) {
            settxnId(dtResponse.data?.txnId);
            setShowOtpBox(true);
            setResendTimer(60);

            toast.success(dtResponse?.data.message || "OTP sent successfully.");
            setIsPageLoading(false);
          } else {
            toast.error(
              dtResponse?.data.message ||
                "Failed to send OTP. Please try again.",
            );
            setIsPageLoading(false);
          }
        // } else {
        //   toast.error("Session creation failed. Please try again.");
        //   setIsPageLoading(false);
        // }
      } else {
        toast.error("Failed to encrypt ABHA address. Please try again.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      // Backend returned an error response
      if (
        error.response?.data?.success === false &&
        error.response?.data?.message === "Unclassified Authentication Failure"
      ) {
        toast.error(error.response.data.message + ". Please try again!");
      } else if (
        error.response?.data?.success === false &&
        error.response?.data?.message ===
          "This account is deactivated. Please continue to reactivate."
      ) {
        setShowDeactivateMessage(error.response.data.message);
      } else {
        toast.error(
          error.response?.data?.message ||
            "Server error occurred. Please try again later.",
        );
      }
    }
  };

  /**
   * Function used to resend OTP
   */
  const handleResendOtp = async () => {
    if (resendCount >= 3) {
      toast.error("Maximum resend attempts reached.");
      return;
    }
    if (resendTimer > 0) {
      toast.error("Please wait before resending OTP.");
      return;
    }

    setIsPageLoading(true);
    try {
      const encryptedAbhaAddress = await encryptString(abhaAddress);
      if (encryptedAbhaAddress) {
        // const sessionResponse = await createSession();
        // if (sessionResponse?.accessToken) {
          const url = `${API_BASE_URL}/abha/profile/singlelogin/api`;
          const param = {
            loginId: encryptedAbhaAddress,
            verify:
              otpSystem === "aadhaar" ? "aadhaar-verify" : "mobile-verify",
            otpsystem: otpSystem === "aadhaar" ? "aadhaar" : "abdm",
          };
          const header = {
            headers: {
              "Content-Type": "application/json",
              // accesstoken: sessionResponse.accessToken,
            },
          };
          const response = await axios.post(url, param, header);
          const dtResponse = response.data;
          if (dtResponse.success) {
            settxnId(dtResponse.data?.txnId);
            setResendTimer(60);
            setResendCount(resendCount + 1);
            toast.success(
              dtResponse.data.message || "OTP resent successfully.",
            );
            setIsPageLoading(false);
          } else {
            toast.error(
              dtResponse?.data.message ||
                "Failed to resend OTP. Please try again.",
            );
            setIsPageLoading(false);
          }
        // } else {
        //   toast.error("Session creation failed. Please try again.");
        //   setIsPageLoading(false);
        // }
      } else {
        toast.error("Failed to encrypt ABHA address. Please try again.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      toast.error(
        error.response?.data?.message ||
          "Failed to resend OTP. Please try again.",
      );
    }
  };

  /**
   * Function used to verify OTP
   */
  const verifyOtp = async (event) => {
    event.preventDefault();
    setIsPageLoading(true);
    try {
      const encryptedOtp = await encryptString(OtpText);
      if (encryptedOtp) {
        const url = `${API_BASE_URL}/abha/profile/singlelogin/api/verify-otp`;
        const param = {
          txnId: txnId,
          otp: encryptedOtp,
          verify: otpSystem === "aadhaar" ? "aadhaar-verify" : "mobile-verify",
        };
        const header = {
          headers: {
            "Content-Type": "application/json",
            // accesstoken: accessToken,
          },
        };
        const response = await axios.post(url, param, header);
        const dtResponse = response.data;

        if (dtResponse.success) {
          if (dtResponse.data.authResult === "success") {
            // localStorage.setItem("x_token", dtResponse.data.tokens.token);
            localStorage.setItem("loginMethod", "abhaAddress");

            // Get ABHA profile data using address API
            const profileUrl = `${API_BASE_URL}/abha/profile/address`;
            const profileHeader = {
              headers: {
                "Content-Type": "application/json",
                // accesstoken: accessToken,
                // xtoken: `${dtResponse.data.tokens.token}`,
              },
            };
            const profileResponse = await axios.get(profileUrl, profileHeader);
            const abhaProfileData = profileResponse.data;

            if (abhaProfileData?.success) {
              localStorage.setItem(
                "orignalBeneficiaryData",
                JSON.stringify(abhaProfileData?.data),
              );
              localStorage.setItem(
                "abhaProfileData",
                JSON.stringify(abhaProfileData),
              );
              setIsPageLoading(false);
              navigate("/abha-Card");
            } else {
              toast.error(
                abhaProfileData?.message ||
                  "Failed to fetch ABHA profile data. Please try again.",
              );
              setIsPageLoading(false);
              return;
            }
          } else {
            toast.error(
              dtResponse?.data?.message || "Wrong OTP. Please try again.",
            );
            setIsPageLoading(false);
            return;
          }
        } else {
          toast.error(
            dtResponse?.data?.message ||
              "Failed to verify OTP. Please try again.",
          );
          setIsPageLoading(false);
        }
      } else {
        toast.error("Failed to encrypt OTP. Please try again.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      // Backend returned an error response
      if (
        error.response?.data?.success === false &&
        error.response?.data?.message === "Unclassified Authentication Failure"
      ) {
        toast.error(error.response.data.message + ". Please try again!");
      } else {
        toast.error(
          error.response?.data?.message ||
            "Server error occurred. Please try again later.",
        );
      }
    }
  };

  return (
    <>
      {showDeactivateMessage && (
        <DeactivatePopup
          onClose={() => setShowDeactivateMessage("")}
          showDeactivateMessage={showDeactivateMessage}
        />
      )}
      <ToastContainer />
      {isPageLoading && <Loader />}
      <div className="flow-feilds">
        {!showOtpBox && (
          <>
            <div className="feilds">
              <label>
                Enter ABHA Address <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="filds-form"
                placeholder="username@sbx"
                value={abhaAddress}
                autoComplete="off"
                onChange={handleAbhaAddressChange}
                style={{ width: "100%" }}
              />
              {abhaAddressError && (
                <span
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "5px",
                    display: "block",
                  }}
                >
                  {abhaAddressError}
                </span>
              )}
            </div>

            {!searchDone && (
              <div className="feilds feildsBtn" style={{ marginTop: "15px" }}>
                <button
                  className={`custBtn ${abhaAddress.endsWith("@sbx") && abhaAddress !== "@sbx" ? "btnSuccess" : "disabled"}`}
                  disabled={
                    !abhaAddress.endsWith("@sbx") || abhaAddress === "@sbx"
                  }
                  style={{
                    opacity:
                      !abhaAddress.endsWith("@sbx") || abhaAddress === "@sbx"
                        ? 0.5
                        : 1,
                    cursor:
                      !abhaAddress.endsWith("@sbx") || abhaAddress === "@sbx"
                        ? "not-allowed"
                        : "pointer",
                  }}
                  onClick={handleSearch}
                >
                  Search <i className="material-icons">search</i>
                </button>
              </div>
            )}

            {searchDone && (
              <>
                <div className="feilds" style={{ marginTop: "15px" }}>
                  <label>
                    Validate using <span style={{ color: "red" }}>*</span>
                  </label>
                  <div
                    style={{ display: "flex", gap: "30px", marginTop: "10px" }}
                  >
                    {availableAuthMethods.includes("AADHAAR_OTP") && (
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          name="otpSystem"
                          value="aadhaar"
                          checked={otpSystem === "aadhaar"}
                          onChange={(e) => setOtpSystem(e.target.value)}
                        />
                        OTP on mobile number linked with Aadhaar number
                      </label>
                    )}
                    {availableAuthMethods.includes("MOBILE_OTP") && (
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          name="otpSystem"
                          value="abdm"
                          checked={otpSystem === "abdm"}
                          onChange={(e) => setOtpSystem(e.target.value)}
                        />
                        OTP on mobile number linked with ABHA number
                      </label>
                    )}
                  </div>
                </div>

                <div className="feilds" style={{ marginTop: "15px" }}>
                  <label>
                    Captcha <span style={{ color: "red" }}>*</span>
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#f0f0f0",
                        padding: "5px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        flex: 1,
                        textAlign: "center",
                        userSelect: "none",
                        minHeight: "60px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {captchaImage ? (
                        <img
                          src={captchaImage}
                          alt="Captcha"
                          style={{ maxWidth: "100%", height: "auto" }}
                        />
                      ) : (
                        <span style={{ color: "#999" }}>
                          Loading captcha...
                        </span>
                      )}
                    </div>
                    <i
                      className="material-icons"
                      onClick={generateCaptcha}
                      style={{ cursor: "pointer", fontSize: "24px" }}
                      title="Refresh Captcha"
                    >
                      refresh
                    </i>
                  </div>
                  <input
                    type="text"
                    className="filds-form"
                    placeholder="Enter captcha text"
                    value={captchaInput}
                    onChange={(e) => {
                      setCaptchaInput(e.target.value);
                    }}
                    autoComplete="off"
                  />
                </div>
              </>
            )}
          </>
        )}
        {showOtpBox && (
          <>
            <div className="feilds">
              <label>ABHA Address</label>
              <input
                type="text"
                className="filds-form"
                value={abhaAddress}
                disabled
                style={{ background: "#f5f5f5", cursor: "not-allowed" }}
              />
            </div>
            <div className="feilds">
              <label>
                Confirm OTP <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="filds-form"
                placeholder="Enter 6 digit OTP"
                value={OtpText}
                autoComplete="off"
                maxLength={6}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  handleOtpChange({ target: { value } });
                }}
              />
              {otpError && (
                <span
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "5px",
                    display: "block",
                  }}
                >
                  {otpError}
                </span>
              )}
              <span
                className="notes text-end"
                onClick={
                  resendTimer === 0 && resendCount < 3 ? handleResendOtp : null
                }
                style={{
                  pointerEvents:
                    resendTimer > 0 || resendCount >= 3 ? "none" : "auto",
                  color:
                    resendTimer > 0 || resendCount >= 3 ? "#999" : "#007bff",
                  cursor:
                    resendTimer > 0 || resendCount >= 3
                      ? "not-allowed"
                      : "pointer",
                  display: "block",
                  marginTop: "5px",
                }}
              >
                {resendTimer > 0
                  ? `00:${resendTimer < 10 ? "0" + resendTimer : resendTimer} Resend OTP (${3 - resendCount} ${3 - resendCount === 1 ? "attempt" : "attempts"} left)`
                  : resendCount >= 3
                    ? "Maximum resend attempts reached"
                    : `Resend OTP (${3 - resendCount} ${3 - resendCount === 1 ? "attempt" : "attempts"} left)`}
              </span>
            </div>
          </>
        )}
      </div>

      <div className="flow-feilds" style={{ minHeight: "auto" }}>
        <div className="feilds feildsBtn">
          <button className="custBtn btnCancel" onClick={back}>
            Back
          </button>
          {!showOtpBox ? (
            <button
              className={`custBtn ${searchDone && abhaAddress.endsWith("@sbx") && abhaAddress !== "@sbx" && captchaInput.length > 0 && otpSystem ? "btnSuccess" : "disabled"}`}
              disabled={
                !searchDone ||
                !abhaAddress.endsWith("@sbx") ||
                abhaAddress === "@sbx" ||
                captchaInput.length === 0 ||
                !otpSystem
              }
              onClick={handleSendOtp}
            >
              Continue <i className="material-icons">arrow_right_alt</i>
            </button>
          ) : (
            <button
              className={`custBtn ${OtpText.length === 6 ? "btnSuccess" : "disabled"}`}
              disabled={OtpText.length !== 6}
              onClick={verifyOtp}
            >
              Verify <i className="material-icons">arrow_right_alt</i>
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default LoginABHAAddress;
